import React from 'react';

import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { GlobalWorkerOptions } from 'pdfjs-dist';

import privacyPolicyPDF from '../../assets/PRIVACY POLICY GCRYPTON.pdf';

GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.js';

const PrivacyPolicy = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
  });

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'auto' }}>
      <Viewer
        fileUrl={privacyPolicyPDF}
        plugins={[defaultLayoutPluginInstance]}
        theme="dark"
      />
    </div>
  );
};

export default PrivacyPolicy;
